module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_salmon.e0e2d7bd.svg";